import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { DocumentModel } from '@data-layer/models/documents';
import { enumDocumentState, enumDocumentType } from '@data-layer/enums/documents';
import { POA_FILE_URL } from '@constants/constants';

@Component({
  selector: 'company-power-attorney-old',
  templateUrl: './company-power-attorney.component.html',
  styleUrls: ['./company-power-attorney.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CompanyPowerAttorneyOldComponent {
  @Input() public isShowSubheader: boolean = true;
  @Input() public isShowDescription: boolean;
  @Input() public poaDocument: DocumentModel;
  @Input() public isLoadingCompanyPoa: boolean;
  @Input() public isTablet: boolean;

  @Output() public uploadDocument: EventEmitter<File> = new EventEmitter<File>();
  @Output() public deleteDocument: EventEmitter<DocumentModel> = new EventEmitter<DocumentModel>();
  @Output() public updateDocumentState: EventEmitter<enumDocumentState> = new EventEmitter<enumDocumentState>();

  public poaFileUrl: string = POA_FILE_URL;

  protected readonly enumDocumentType = enumDocumentType;
}
